export default __webpack_public_path__ + "static/media/closet5-before3-768w.f072b11d.avif";